<template>
  <!-- 上传资料 -->
  <div class="uploadDataBox comBox">
    <div style="font-size: 0.14rem; color: #333333; margin-bottom: 0.16rem">
      发布视频
    </div>
    <div class="sliderBox">
      <div style="display: flex; justify-content: space-between">
        <span style="font-size: 0.16rem; color: #333333; font-weight: bold">{{
          fileName
          ? fileName
          : ruleForm.videoSource
            ? ruleForm.title +
            "." +
            ruleForm.videoSource.split(".").pop().split("?")[0]
            : ""
        }}</span>
        <!-- <span>重新上传</span> -->
      </div>
      <div style="margin-top: 0.06rem">
        <el-progress v-if="!ruleForm.percentageValue" :percentage="percentageValue" :format="progressValue" />
        <el-progress v-else :percentage="ruleForm.percentageValue" :format="progressValue" />
      </div>
      <!-- <div>重新上传</div> -->
    </div>
    <el-form ref="ruleFormRef" :model="ruleForm" label-width="100px" :rules="rules" class="demo-ruleForm" :size="formSize"
      status-icon label-position="left">
      <!-- {{ ruleForm.videoSource }} -->
      <el-form-item label="封面" prop="coverSheet" style="position: relative">
        <!-- <el-image v-if="ruleForm.coverSheet" :src="require('@/assets/module_share_open.png')" class="img-Off"
          @click="OffFile" />
        <el-image class="upload-demo" v-if="ruleForm.coverSheet" :src="ruleForm.coverSheet">
          <template #error>
            <div class="image-slot">
              <el-icon class="el-icon--upload">
                <div style="
                    width: 0.2rem;
                    height: 0.2rem;
                    background: url(data:image/png;base64,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);
                    background-size: 100%;
                    background-repeat: no-repeat;
                  "></div>
              </el-icon>
              <div class="el-upload__text">
                <div style="font-size: 0.14rem; color: #333333">
                  点击或拖拽文件到此处上传
                </div>
                <div style="font-size: 0.12rem; color: #86909c">
                  图片尺寸至少302*180
                </div>
                <div style="font-size: 0.12rem; color: #86909c">
                  支持JPG/PNG，不超过6MB
                </div>
              </div>
            </div>
          </template>
        </el-image> -->
        <el-upload class="upload-demo" :show-file-list="false" drag :before-upload="beforeUpload" :action="upload_action"
          :on-success="onSuccess">
          <el-image v-if="ruleForm.coverSheet" :src="ruleForm.coverSheet"></el-image>
          <div v-else>
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              <div style="font-size: 0.14rem; color: #333333">
                点击或拖拽文件到此处上传
              </div>
              <div style="font-size: 0.12rem; color: #86909c">
                图片尺寸至少302*180
              </div>
              <div style="font-size: 0.12rem; color: #86909c">
                支持JPG/PNG，不超过6MB
              </div>
            </div>
          </div>
          <div
            style="position: absolute;bottom:0;left:0px;width: 300px;background-color: rgba(51, 51,51 , .3);height: 35px;z-index: 99;color: #FFF;line-height: 35px;">
            <div style="display: flex;justify-content: space-between;align-items: center;">
              <div style="flex:1;text-align: center;cursor: pointer;"><span>本地上传</span></div>
              <div style=""><span>|</span></div>
              <div @click.stop="coverClick" style="flex:1;text-align: center;cursor: pointer;"><span>推荐封面</span></div>
            </div>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="标题" prop="title">
        <el-input v-model="ruleForm.title" show-word-limit maxlength="40" placeholder="请输入标题" />
      </el-form-item>
      <el-form-item label="视频简介" prop="introduction">
        <el-input type="textarea" show-word-limit maxlength="1000" v-model="ruleForm.introduction"
          placeholder="请输入视频简介" />
      </el-form-item>
      <el-form-item label="分类" prop="category1Id">
        <div style="display: flex; justify-content: space-between; width: 100%">
          <!-- <el-input v-model="ruleForm.name" placeholder="*请选择分类一" /> -->
          <el-select v-model="ruleForm.category1Id" placeholder="请选择分类" style="width: 100%">
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <!-- <div style="width: 0.24rem"></div>
          <el-select
            v-model="ruleForm.category2Id"
            placeholder="请选择分类"
            style="width: 45%"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select> -->
        </div>
      </el-form-item>
      <el-form-item label="标签" prop="tags">
        <!-- <el-input v-model="ruleForm.tags" /> -->
        <el-select class="tagType" style="width: 100%" v-model="ruleForm.tags" clearable multiple filterable
          id="selecttagsId" :reserve-keyword="false" allow-create default-first-option
          placeholder="最多添加10个标签,每个标签最多20个字,按回车Enter创建标签" multiple-limit="10" :s="''" @input.native="handleInput">
          <el-option v-for="item in tags1" :key="item" :label="item" :value="item" />
        </el-select>
      </el-form-item>
      <el-form-item label="授权方式" prop="authorizationMode">
        <el-select v-model="ruleForm.authorizationMode" style="width: 100%">
          <el-option v-for="(item, index) in AuthorizationModeList" :key="index" :label="item.label" :value="item.value">
            <template #default>
              <span v-if="item.img">
                <img v-for="(img, imgIndex) in item.img" :key="imgIndex" :src="require(`@/assets/${img}`)" style="
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                    border: 1px solid #fff;
                    border-radius: 50%;
                  " />
              </span>
              <span style="line-height: 104px" v-else class="circle-span"></span>
              {{ item.label }}
            </template>
          </el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="片中职务" prop="name">
        <el-select
          class="tagType"
          style="width: 100%"
          v-model="jobs"
          clearable
          multiple
          filterable
          allow-create
          default-first-option
          placeholder="可添加1-5个职务"
          no-data-text="请添加数据"
        >
          <el-option
            v-for="item in jobs"
            :key="item"
            :label="item"
            :value="item"
          />
        </el-select>
      </el-form-item> -->
      <!-- <el-form-item label="其他创作人">
        <div style="width: 100%; margin-bottom: 5px">
          <el-row :gutter="12">
            <template :key="index" v-for="(item, index) in other">
              <el-col :span="8">
                <el-card shadow="always">
                  <div class="flex">
                    <div style="flex: 1">
                      <el-avatar
                        :size="50"
                        :src="item.avatar"
                        v-if="item.avatar"
                      />
                      <el-avatar
                        v-else
                        :src="require('../../assets/logo.png')"
                      ></el-avatar>
                    </div>
                    <div style="flex: 2">
                      <div>{{ item.name }}</div>
                      <div>{{ item.profess }}</div>
                    </div>
                    <div style="width: 20px" @click="handleDelete(index)">
                      <el-icon
                        style="cursor: pointer"
                        :size="30"
                        color="#86909C"
                      >
                        <Delete />
                      </el-icon>
                    </div>
                  </div>
                </el-card>
              </el-col>
            </template>
          </el-row>
        </div> -->

      <!-- <div class="other" @click="handelCreate">
          <span>添加创作人</span>
        </div> -->
      <!-- </el-form-item> -->
      <!-- <el-form-item label="授权方式" prop="radio">
        <el-radio-group v-model="ruleForm.authorizationMode" size="small">
          <el-radio :label="1" border>不采用共享协议</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-form-item label="评论权限" prop="radio">
        <el-radio-group v-model="ruleForm.commentPermissions" class="ml-4">
          <el-radio :label="1" size="small">开启评论</el-radio>
          <el-radio :label="2" size="small">关闭评论</el-radio>
        </el-radio-group>
      </el-form-item> -->
      <!-- <el-form-item label="发布方式" prop="radio">
        <div style="display: flex">
          <el-radio-group v-model="ruleForm.publishMode" class="ml-4">
            <el-radio :label="0" size="small">公开发布</el-radio>
            <el-radio :label="1" size="small">仅自己可见</el-radio>
          </el-radio-group>
          <div style="font-size: 0.12rem; color: #86909c; margin-left: 0.24rem">
            完成实名认证后，刷新页面即可公开发布&nbsp;&nbsp;<span
              style="color: #C01A26"
              >去认证</span
            >
          </div>
        </div>
      </el-form-item> -->
    </el-form>
    <el-button type="primary" :loading="loading" class="dataBtn" @click="onSubmit">提交审核</el-button>
    <el-dialog title="查找创作者" v-model="openCreateUser" append-to-body width="350px" :close-on-click-modal="false">
      <el-form>
        <el-form-item>
          <el-input placeholder="请输入成员昵称" v-model="nickName" clearable @keyup.enter="handleQuery" />
        </el-form-item>
      </el-form>
      <div style="display: flex; justify-content: center">
        <div class="dataBtnClose" @click="openCreateUser = false">取消</div>
        <div class="dataBtnSubmit" @click="handleQuery">确认</div>
      </div>
    </el-dialog>
    <el-dialog style="border-radius: 12px;" top="33px" v-model="dialogVisible" close-icon="CircleCloseFilled"
      title="选择推荐封面" width="700">
      <div style="">
        <div style="height: 329px;width: 100%;">
          <img style="height: 329px;width: 100%;border-radius: 8px;" :src="checkImg" alt="" srcset="">
        </div>
        <div
          style="display: grid;grid-template-columns: repeat(5, minmax(0, 1fr));column-gap: 12px;row-gap: 12px;margin-top: 20px;">
          <div @click="checkImg = item" v-for="item in props.jpimg" :key="item">
            <img style="height: 65px;border-radius: 8px;width: 100%;cursor: pointer;" :src="item" alt="" srcset="">
          </div>
        </div>
        <div class=""
          style="display: flex;justify-content: center;align-items: center;column-gap: 20px;margin-top: 20px;">
          <div @click="dialogVisible = false"
            style="cursor: pointer;border-radius: 8px;border: 1px solid #86909C;width: 88px;height: 37px; color: #333333; font-size: 14px;text-align: center;line-height: 37px;">
            <span>取消</span>
          </div>
          <div @click="saveClick"
            style="cursor: pointer;border-radius: 8px;width: 88px;height: 37px;background: #2978FF; color: #ffffff; font-size: 14px;text-align: center;line-height: 37px;">
            <span>保存</span>
          </div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { UploadFilled, Search, Delete } from "@element-plus/icons-vue";
import { reactive, ref, watch } from "vue";
import { FormInstance, FormRules, ElMessage } from "element-plus";
import { Axios } from "../../assets/js/ls_com_axios.js";
import { serverBaseUrl } from "../../assets/js/ls_tgServerUrls.js";
import { useRouter } from "vue-router";
import axios from "axios"
import uploadByPieces from "@/assets/js/uploadNew";
const dialogVisible = ref(false);
interface RuleForm {
  title: string;
  introduction: string;
  coverSheet: string;
  category1Id?: number;
  category2Id?: number;
  category1?: string;
  category2?: string;
  tags?: any;
  jobs?: string;
  video: string;
  authorizationMode: number;
  commentPermissions: number;
  publishMode: number;
  otherComposer: string;
}
const formSize = ref("default");
const props = defineProps({
  percentageValue: Number,
  filePath: String,
  fileName: String,
  jpimg: Array,
});
const checkImg: any = ref("")
const coverClick = () => {
  checkImg.value = ruleForm.value.coverSheet ? ruleForm.value.coverSheet : props.jpimg[0];
  dialogVisible.value = true;
}
const base_file = (base64String: any, fileName: string) => {
  const byteCharacters = atob(base64String.split(',')[1]);
  const mimeString = base64String.split(',')[0].split(':')[1].split(';')[0];
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: mimeString });
  return new File([blob], fileName, { type: mimeString });
}
const saveClick = async () => {
  if (checkImg.value.indexOf("base64") != -1) {
    let file = base_file(checkImg.value, String(new Date().getTime()));
    let p = new FormData();
    p.append("file", file);
    let res = await axios.post('https://api.biaoshisx.com/file/upload', p);
    if (res.data.code == 200) {
      let s: any = props.jpimg?.findIndex((item) => item === checkImg.value);
      props.jpimg?.splice(s, 1, res.data.data.url);
      ruleForm.value.coverSheet = res.data.data.url;
      dialogVisible.value = false;
    } else {
      ElMessage.error("操作失败");
    }
  } else {
    ruleForm.value.coverSheet = checkImg.value;
    dialogVisible.value = false;
  }
}

const openCreateUser = ref(false);
const upload_action = ref(serverBaseUrl + "/file/upload");
const nickName = ref("");
const other = ref<Array<any>>([]);
const tags = ref<Array<any>>([]);
const jobs = ref<Array<any>>([]);
const handleInput = (value) => {
  // console.log(value);
  // if (value) {
  //   return ElMessage.warning("最多输入10个标签");
  // }
  const selectId = document.querySelector("#selecttagsId");
  if (selectId) {
    selectId.setAttribute("maxLength", 10);
  }
  // if (value && value.target.value.length > 10) {
  //   let inputValue = value.target.value;
  //   const truncatedValue = inputValue.slice(0, 10);
  //   ruleForm.value.tags.pop();
  //   ruleForm.value.tags.push(truncatedValue);
  //   return ElMessage.warning("最多输入10个标签");
  // }
};
handleInput();
const AuthorizationModeList = ref([
  {
    value: 1,
    label: "不采用共享协议",
  },
  {
    value: 2,
    label: "署名-非商业性使用-禁止演绎",
    img: [
      "AuthorizationMode3.png",
      "AuthorizationMode4.png",
      "AuthorizationMode1.png",
    ],
  },
  {
    value: 3,
    label: "署名-非商业性使用-相同方式共享",
    img: [
      "AuthorizationMode3.png",
      "AuthorizationMode4.png",
      "AuthorizationMode2.png",
    ],
  },
  {
    value: 4,
    label: "署名-非商业性使用",
    img: ["AuthorizationMode3.png", "AuthorizationMode4.png"],
  },
  {
    value: 5,
    label: "署名-禁止演绎",
    img: ["AuthorizationMode3.png", "AuthorizationMode1.png"],
  },
  {
    value: 6,
    label: "署名-相同方式共享",
    img: ["AuthorizationMode3.png", "AuthorizationMode2.png"],
  },
  {
    value: 7,
    label: "署名",
    img: ["AuthorizationMode3.png"],
  },
]);
const router = useRouter();
const progressValue = (percentage: number) =>
  percentage === 100 ? "上传已完成" : `${percentage}%`;

// do not use same name with ref
const ruleForm = ref<RuleForm>({
  title: "",
  video: "",
  tags: [],
  introduction: "",
  coverSheet: "",
  commentPermissions: 1,
  publishMode: 0,
  authorizationMode: null,
  otherComposer: "",
});
let timer = <any>null; // 声明一个计时器变量
const handleEnter = (e: any) => { };
// console.log(val.trim());
// if (val.trim() !== "" && !tags1.value.includes(val.trim())) {
//   tags1.value.push(val.trim());
//   // Clear input value
//   e.target.value = "";
// }
// Update the v-model value
// ruleForm.value.tags = tags1.value;
// tags1.value = ruleForm.value.tags;
const handleRemove = (tag: any) => {
  tags1.value.at(-1) == tag ? tags1.value.pop() : "";
};
const tags1 = ref<Array<any>>([]);
const rules = reactive<FormRules<RuleForm>>({
  coverSheet: [{ required: true, message: "请上传封面", trigger: "change" }],
  title: [{ required: true, message: "请输入标题", trigger: "change" }],
  introduction: [{ required: true, message: "请输入简介", trigger: "change" }],
  category1Id: [{ required: true, message: "请选择分类", trigger: "change" }],
  tags: [{ required: true, message: "请输入标签", trigger: "change" }],
  authorizationMode: [
    { required: true, message: "请选择授权方式", trigger: "change" },
  ],
});
const ruleFormRef = ref<FormInstance>();
const OffFile = () => {
  ruleForm.value.coverSheet = "";
};
const loading = ref(false);
const beforeUpload = (file: any) => {
  const isJPGorPNG = file.type === "image/jpeg" || file.type === "image/png";
  const isLt6M = file.size / 1024 / 1024 < 6;

  if (!isJPGorPNG) {
    ElMessage.warning("只能上传JPG/PNG格式的文件!");
    return false;
  }
  if (!isLt6M) {
    ElMessage.warning("上传文件大小不能超过 6MB!");
    return false;
  }
  return isJPGorPNG && isLt6M;
};
const onSubmit = () => {
  ruleFormRef.value.validate(async (valid: boolean) => {
    if (valid) {
      let id = router.currentRoute.value.query.id;
      if (
        router.currentRoute.value.query.id
          ? ruleForm.value.percentageValue !== 100
          : props.percentageValue !== 100
      ) {
        return ElMessage.warning("请等待文件上传完成");
      }

      if (!props.filePath && !id) {
        return ElMessage.warning("请等待文件上传完成");
      }
      ruleForm.value.video = props.filePath;
      console.log(ruleForm.value.video);
      loading.value = true;
      let obj = { ...ruleForm.value };
      obj.tags = obj.tags.join(",");
      if (ruleForm.value.category1Id) {
        ruleForm.value.category1 = options.value.find(
          (x) => x.id == ruleForm.value.category1Id
        ).name;
      }
      if (ruleForm.value.category2Id) {
        ruleForm.value.category2 = options.value.find(
          (x) => x.id == ruleForm.value.category2Id
        ).name;
      }
      try {
        Axios("post", "/material/material/work/sou", obj, false, (res) => {
          if (res.data.code == 200) {
            loading.value = false;
            router.push({
              path: "ShadowUser",
            });
          } else {
            loading.value = false;
          }
        });
      } catch (err) {
        console.log(err);
      } finally {
        loading.value = false;
      }
    } else {
      return false;
    }
  });
};
const onSuccess = (res: any) => {
  ruleForm.value.coverSheet = res.data.url;
};
const options = ref([]);
const getTypes = () => {
  Axios(
    "post",
    "/material/material/workCategory/list",
    {
      pageIndex: 1,
      pageSize: 1000,
    },
    false,
    (res) => {
      options.value = res.data.data.records;
      options.value.shift();
    }
  );
};
const handelCreate = () => {
  openCreateUser.value = true;
};
const handleDelete = (index: number) => {
  other.value.splice(index, 1);
};
const handleQuery = () => {
  if (nickName.value) {
    Axios(
      "get",
      "/member/by",
      {
        nickName: nickName.value,
      },
      false,
      (res: any) => {
        if (!res.data.data) {
          ElMessage.warning("不存在此昵称的创作者");
          return;
        }
        if (other.value.findIndex((x) => x.id == res.data.memberId) > -1) {
          ElMessage.warning("已存在当前创作者");
          return;
        }
        let profess = "暂无职务";
        if (res.data.profess) {
          profess = res.data.profess;
        } else if (res.data.industry) {
          profess = res.data.industry;
        }
        other.value.push({
          id: res.data.data.memberId,
          name: res.data.data.nickName,
          avatar: res.data.data.avatar,
          profess: profess,
        });
        openCreateUser.value = false;
      }
    );
  }
};
const init = () => {
  let id = router.currentRoute.value.query.id;
  if (id) {
    Axios("get", `/material/material/work/${id}`, "", false, function (res) {
      if (res.data.code == 200) {
        // console.log(res);
        res.data.data.category3 = "";
        // tags1.value = res.data.data.tags.split(",");
        // res.data.data.tags = tags1.value;

        // console.log("tags1tags1tags1tags1tags1tags1tags1", tags1.value);

        ruleForm.value = res.data.data;
        // console.log(res.data.data.tags.split(","));

        ruleForm.value.tags = res.data.data.tags.split(",");
        // ruleForm.value.tags = res.data.data.tags.split(",");
        ruleForm.value.percentageValue = 100;
        // props.percentageValue = 100;
        // console.log(ruleForm.value);
      } else {
        ElMessage.error(res.data.message);
      }
      console.log("==========");
    });
  }
};
router.currentRoute.value.query ? init() : "";
// watch(
//   () => props.filePath,
//   (v: any) => {
//     ruleForm.value.video = v;
//   }
// );
watch(other.value, (v: any) => {
  ruleForm.value.otherComposer = v.map((x: any) => x.id).join(",");
});
// watch(
//   () => tags.value,
//   (v) => {
//     ruleForm.value.tags = v.join(",");
//   }
// );
watch(
  () => jobs.value,
  (v) => {
    ruleForm.value.jobs = v.join(",");
  }
);
getTypes();
</script>

<style scoped>
@import url(/src/assets/css/com.css);

.uploadDataBox {
  background: #ffffff;
  border-radius: 0.08rem;
  opacity: 1;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 0.3rem auto 0.3rem;
  padding: 0.8rem;
}

.sliderBox {
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  background: #f5f5f5;
  padding: 0.24rem 0.24rem 0.32rem;
  box-sizing: border-box;
  margin: 0.16rem 0 0.24rem;
}

.upload-demo {
  width: 3.02rem;
  height: 180px;
  object-fit: cover;
  border-radius: 8px;
  /* margin-bottom: 0.24rem; */
}

.flex {
  display: flex;
  align-items: center;
}

/deep/.el-upload-dragger {
  background: #f5f5f5;
  padding: 0;
  height: 180px;
  border-radius: 8px;
}

/deep/.el-upload-dragger .el-image {
  width: 100%;
  height: 100%;
}

.dataBtn {
  width: 5.68rem;
  padding: 0.12rem 1.06rem;
  background: #c01a26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
  cursor: pointer;
}

.other {
  background: rgba(255, 96, 0, 0.2);
  border-radius: 0.08rem;
  opacity: 1;
  font-size: 0.14rem;
  color: #c01a26;
  padding: 0.12rem;
  cursor: pointer;
}

/deep/.el-form-item__label {
  /* width: 1.7rem!important; */
  color: #333333 !important;
  text-align: left !important;
}

/deep/.el-form-item--default {
  font-size: 0.14rem !important;
}

/deep/.el-radio__label {
  color: #333 !important;
}

/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #c01a26 !important;
  background: #c01a26 !important;
}

.img-Off {
  position: absolute;
  z-index: 11;
  left: 2.85rem;
  top: -10px;
  width: 40px;
  height: 40px;
}

.img-text {
  position: absolute;
  bottom: 0;
  text-align: center;
  width: 3.02rem;
  font-size: 12px;
  z-index: 12;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 0px 0px 0px 0px;
  color: #fff;
  font-size: 12px;
}

.circle-span {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1px solid #86909c;
  border-radius: 50%;
  line-height: 13px;
  /* 调整行高以适应文字 */
  vertical-align: middle;
  /* 垂直居中对齐 */
}

.el-select-dropdown__item {
  line-height: 34px;
}

/deep/ input[type="file"] {
  display: none;
}

/deep/ .el-upload__input {
  display: none;
}

/deep/ .el-button {
  border: 1px solid transparent;
}
</style>
